import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { register, googleSSO } from "../store/auth/thunks";
import { GoogleLogin } from "@react-oauth/google";
import states from "../data/states";
import '../styles/signup.css';
import '../styles/profile.css';

import {
  Flex,
  Text,
  Heading,
  Input,
  Button,
  InputGroup,
  Stack,
  Center,
  Spinner,
  Select,
  Box,
  Link,
  useColorMode,
  FormControl,
  FormHelperText,
  InputRightElement,
  Divider,
  HStack,
} from "@chakra-ui/react";
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";


import useToastNotification from "../hooks/useToastNotification";
import useAsyncState from "../hooks/useAsyncState";

export default function Signup() {
  const dispatch = useDispatch();
  const showToast = useToastNotification();
  /*
  const [userInfo, setUserInfo] = useState({
    first_name: "",
    last_name: "",
    birthday: "",
    email: "",
    street_address: "",
    city: "",
    state: "",
    country: ""
  })
  */
  const [showPassword, setShowPassword] = useState(false);
  useAsyncState({
    onError: (info) => showToast(info?.response?.data?.result, { status: "error" }),
  });

  const [first_name, setFirstName] = useState("");
  const [last_name, setLastName] = useState("");
  const [birthday, setBirthday] = useState("");
  const [email, setEmail] = useState("");
  const [phone_number, setPhoneNumber] = useState("");
  const [password, setPassword] = useState("");
  const [street_address, setStreetAddress] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");

  const authLoading = useSelector((state) => state.ui.loading);

  const { colorMode } = useColorMode();

  useEffect(() => {
    const savedUserInfo = window.localStorage.getItem('userInfo');
    if (savedUserInfo) {
      const userInfo = JSON.parse(savedUserInfo);
      setFirstName(userInfo.first_name || "");
      setLastName(userInfo.last_name || "");
      setBirthday(userInfo.birthday || "");
      setEmail(userInfo.email || "");
      setPhoneNumber(userInfo.phone_number || "");
      setPassword("");
      setStreetAddress(userInfo.street_address || "");
      setCity(userInfo.city || "");
      setState(userInfo.state || "");
      setCountry(userInfo.country || "");
      // Clear the saved info after loading it
      //window.localStorage.removeItem('userInfo');
    }
  }, []); // Empty dependency array means this runs once on mount

  function clearFormStates() {
    setFirstName("");
    setLastName("");
    setBirthday("");
    setEmail("");
    setPhoneNumber("");
    setPassword("");
    setStreetAddress("");
    setCity("");
    setState("");
    setCountry("");
    window.localStorage.removeItem('userInfo');
  }

  const handleClear = (e) => {
    e.preventDefault();
    clearFormStates();
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    const userInfo = {
      first_name,
      last_name,
      birthday,
      email,
      phone_number,
      //password,
      street_address,
      city,
      state,
      country,
    };
    await dispatch(
      register({
        first_name,
        last_name,
        birthday, //birthday.join("-"), // if its XX-XX-XXXX format
        email,
        phone_number,
        password,
        street_address,
        city,
        state,
        country,
      })
    );
    window.localStorage.setItem('userInfo', JSON.stringify(userInfo));
  };

  const handleGoogleSuccess = async (credentialResponse) => {
    await dispatch(googleSSO({ credential: credentialResponse.credential }));
  };

  const handleGoogleError = () => {
    showToast("Google sign-up failed", {
      description: "Could not complete Google sign-up. Please try again or fill in the form manually.",
      status: "error",
      duration: 5000,
    });
  };

  const [showPasswordModal, setShowPasswordModal] = useState(false);

  function handlePasswordChange(event) {
    setPassword(event.target.value);
  }

  function handleShowPasswordModal() {
    if(password.length === 0){
      setShowPasswordModal(true);
    }
  }

  function handleHidePasswordModal() {
    setTimeout(() => {
      setShowPasswordModal(false);
    }, 100);
  }

  useEffect(() => {
    if(password.length >= 1){
      handleHidePasswordModal();
    }
  }, [password]);

  function handleGeneratePassword() {
    const passwordLength = 16; // Set password length
    const passwordChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+"; // Set password character set
    let newPassword = "";
    let crypto = window.crypto || window.msCrypto; // Get crypto API

    // Generate random password string
    while (newPassword.length < passwordLength) {
      let randomBytes = new Uint8Array(1);
      crypto.getRandomValues(randomBytes);
      let charIndex = randomBytes[0] % passwordChars.length;
      newPassword += passwordChars.charAt(charIndex);
    }

    setPassword(newPassword);
    handleHidePasswordModal();
  }

  // grabbing current date to set a max to the birthday input
  const currentDate = new Date();
  let [month, day, year] = currentDate.toLocaleDateString().split("/");
  // input max field must have 08 instead of 8
  month = month.length === 2 ? month : "0" + month;
  day = day.length === 2 ? day : "0" + day;
  const maxDate = year + "-" + month + "-" + day;

  return (
    <Flex
      direction="column"
      minH="100vh"
      bg={colorMode === 'light' ? "gray.200" : "gray.800"}
      justifyContent="flex-start"
      alignItems="center"
      overflow="auto"
      pt={5}
      pb={10}
    >
      <Stack
        className='profilestack'
      >
        <Box w={{ base: "90%", md: "500px", lg: "540px" }} rounded="lg" overflow="hidden" boxShadow="2px 4px 4px rgba(0,0,0,0.2)">
        {authLoading ? 
          <Stack
              spacing={4}
              p="1rem"
              backgroundColor={colorMode === 'light' ? "whiteAlpha.900" : "whiteAlpha.100"}
              boxShadow="md"
            >
            <Center>
            <Spinner
                thickness='4px'
                speed='0.65s'
                emptyColor='gray.200'
                color='blue.500'
                size='xl'
            />
            </Center>
          </Stack>
        :
          <form>
            <Stack
              spacing={2}
              p="1rem"
              backgroundColor={colorMode === 'light' ? "whiteAlpha.900" : "whiteAlpha.100"}
              boxShadow="md"
            >
              <Link href="/" color="blue.500" fontSize="sm" ml={1}>
                ← Back to home
              </Link>
              <Flex justify="space-between" align="center">
                <Heading className="page-heading" fontSize="xl" ml={1} mb={0} color={colorMode === 'light' ? 'gray.600' : 'gray.200'}>Sign Up</Heading>
                <Button
                  size="sm"
                  variant="ghost"
                  colorScheme="gray"
                  borderRadius="md"
                  onClick={handleClear}
                >
                  Clear
                </Button>
              </Flex>
              <Box display="flex">
                <FormControl>
                  <FormHelperText mb={1} ml={1}>
                    First Name *
                  </FormHelperText>
                  <Input
                    value={first_name}
                    type="text"
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                </FormControl>
                <FormControl>
                  <FormHelperText mb={1} ml={1}>
                    Last Name *
                  </FormHelperText>
                  <Input
                    value={last_name}
                    type="text"
                    onChange={(e) => setLastName(e.target.value)}
                  />
                </FormControl>
              </Box>
              <FormControl>
                <FormHelperText mb={1} ml={1}>
                  Email *
                </FormHelperText>
                <Input value={email} type="text" onChange={(e) => setEmail(e.target.value)} />
              </FormControl>
              <FormControl>
                <FormHelperText mb={1} ml={1}>
                  Password *
                </FormHelperText>
                <InputGroup>
                  <Input
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onFocus={handleShowPasswordModal}
                    onBlur={handleHidePasswordModal}
                    autoComplete="new-password"
                    onChange={handlePasswordChange}
                  />
                  <InputRightElement width="4.5rem">
                    <Button
                      variant={"ghost"}
                      onClick={() =>
                        setShowPassword((showPassword) => !showPassword)
                      }
                    >
                      {showPassword ? <ViewIcon /> : <ViewOffIcon />}
                    </Button>
                  </InputRightElement>
                </InputGroup>
              </FormControl>
              {showPasswordModal && (
                <div>
                  <div>
                    <Center>
                      <Text fontSize="sm" paddingBottom={2}>Would you like to generate a strong password?</Text>
                      </Center>
                    <Center>
                      <Button size="sm" onClick={handleGeneratePassword}>Generate Strong Password</Button>
                    </Center>
                  </div>
                  <div  onClick={handleHidePasswordModal} />
                </div>
              )}
              <FormControl>
                <FormHelperText mb={1} ml={1}>
                  Birthday
                </FormHelperText>
                <InputGroup>
                  <Input
                    type="date"
                    value={birthday}
                    max={maxDate}
                    min="1900-01-01"
                    onChange={(e) => setBirthday(e.target.value)}
                  />
                </InputGroup>
              </FormControl>
              <FormControl>
                <FormHelperText mb={1} ml={1}>
                  Phone Number (Include +Country Code if Non-US)
                </FormHelperText>
                <Input
                  value={phone_number}
                  type="text"
                  onChange={(e) => setPhoneNumber(e.target.value)}
                />
              </FormControl>
              <Box display="flex">
              <FormControl>
                  <FormHelperText mb={1} ml={1}>
                    Street Address
                  </FormHelperText>
                  <Input
                    value={street_address}
                    type="text"
                    onChange={(e) => setStreetAddress(e.target.value)}
                  />
              </FormControl>

              <FormControl>
                  <FormHelperText mb={1} ml={1}>
                    City
                  </FormHelperText>
                  <Input
                    value={city}
                    type="text"
                    onChange={(e) => setCity(e.target.value)}
                  />
              </FormControl>
              </Box>

              <Box display="flex">
              <FormControl>
                  <FormHelperText mb={1} ml={1}>
                    State
                  </FormHelperText>
                  <Select value={state} placeholder='Select State' onChange={(e) => setState(e.target.value)}>
                    {states.map((state) => (<option key={state}>{state}</option>))}
                  </Select>
              </FormControl>

              <FormControl>
                  <FormHelperText mb={1} ml={1}>
                    Country
                  </FormHelperText>
                  <Select value={country} placeholder='Select Country' onChange={(e) => setCountry(e.target.value)}>
                    <option value="Afghanistan">Afghanistan</option>
                    <option value="Albania">Albania</option>
                    <option value="Algeria">Algeria</option>
                    <option value="American Samoa">American Samoa</option>
                    <option value="Andorra">Andorra</option>
                    <option value="Angola">Angola</option>
                    <option value="Anguilla">Anguilla</option>
                    <option value="Antartica">Antarctica</option>
                    <option value="Antigua and Barbuda">Antigua and Barbuda</option>
                    <option value="Argentina">Argentina</option>
                    <option value="Armenia">Armenia</option>
                    <option value="Aruba">Aruba</option>
                    <option value="Australia">Australia</option>
                    <option value="Austria">Austria</option>
                    <option value="Azerbaijan">Azerbaijan</option>
                    <option value="Bahamas">Bahamas</option>
                    <option value="Bahrain">Bahrain</option>
                    <option value="Bangladesh">Bangladesh</option>
                    <option value="Barbados">Barbados</option>
                    <option value="Belarus">Belarus</option>
                    <option value="Belgium">Belgium</option>
                    <option value="Belize">Belize</option>
                    <option value="Benin">Benin</option>
                    <option value="Bermuda">Bermuda</option>
                    <option value="Bhutan">Bhutan</option>
                    <option value="Bolivia">Bolivia</option>
                    <option value="Bosnia and Herzegowina">Bosnia and Herzegowina</option>
                    <option value="Botswana">Botswana</option>
                    <option value="Bouvet Island">Bouvet Island</option>
                    <option value="Brazil">Brazil</option>
                    <option value="British Indian Ocean Territory">British Indian Ocean Territory</option>
                    <option value="Brunei Darussalam">Brunei Darussalam</option>
                    <option value="Bulgaria">Bulgaria</option>
                    <option value="Burkina Faso">Burkina Faso</option>
                    <option value="Burundi">Burundi</option>
                    <option value="Cambodia">Cambodia</option>
                    <option value="Cameroon">Cameroon</option>
                    <option value="Canada">Canada</option>
                    <option value="Cape Verde">Cape Verde</option>
                    <option value="Cayman Islands">Cayman Islands</option>
                    <option value="Central African Republic">Central African Republic</option>
                    <option value="Chad">Chad</option>
                    <option value="Chile">Chile</option>
                    <option value="China">China</option>
                    <option value="Christmas Island">Christmas Island</option>
                    <option value="Cocos Islands">Cocos (Keeling) Islands</option>
                    <option value="Colombia">Colombia</option>
                    <option value="Comoros">Comoros</option>
                    <option value="Congo">Congo</option>
                    <option value="Congo">Congo, the Democratic Republic of the</option>
                    <option value="Cook Islands">Cook Islands</option>
                    <option value="Costa Rica">Costa Rica</option>
                    <option value="Cota D'Ivoire">Cote d'Ivoire</option>
                    <option value="Croatia">Croatia (Hrvatska)</option>
                    <option value="Cuba">Cuba</option>
                    <option value="Cyprus">Cyprus</option>
                    <option value="Czech Republic">Czech Republic</option>
                    <option value="Denmark">Denmark</option>
                    <option value="Djibouti">Djibouti</option>
                    <option value="Dominica">Dominica</option>
                    <option value="Dominican Republic">Dominican Republic</option>
                    <option value="East Timor">East Timor</option>
                    <option value="Ecuador">Ecuador</option>
                    <option value="Egypt">Egypt</option>
                    <option value="El Salvador">El Salvador</option>
                    <option value="Equatorial Guinea">Equatorial Guinea</option>
                    <option value="Eritrea">Eritrea</option>
                    <option value="Estonia">Estonia</option>
                    <option value="Ethiopia">Ethiopia</option>
                    <option value="Falkland Islands">Falkland Islands (Malvinas)</option>
                    <option value="Faroe Islands">Faroe Islands</option>
                    <option value="Fiji">Fiji</option>
                    <option value="Finland">Finland</option>
                    <option value="France">France</option>
                    <option value="France Metropolitan">France, Metropolitan</option>
                    <option value="French Guiana">French Guiana</option>
                    <option value="French Polynesia">French Polynesia</option>
                    <option value="French Southern Territories">French Southern Territories</option>
                    <option value="Gabon">Gabon</option>
                    <option value="Gambia">Gambia</option>
                    <option value="Georgia">Georgia</option>
                    <option value="Germany">Germany</option>
                    <option value="Ghana">Ghana</option>
                    <option value="Gibraltar">Gibraltar</option>
                    <option value="Greece">Greece</option>
                    <option value="Greenland">Greenland</option>
                    <option value="Grenada">Grenada</option>
                    <option value="Guadeloupe">Guadeloupe</option>
                    <option value="Guam">Guam</option>
                    <option value="Guatemala">Guatemala</option>
                    <option value="Guinea">Guinea</option>
                    <option value="Guinea-Bissau">Guinea-Bissau</option>
                    <option value="Guyana">Guyana</option>
                    <option value="Haiti">Haiti</option>
                    <option value="Heard and McDonald Islands">Heard and Mc Donald Islands</option>
                    <option value="Holy See">Holy See (Vatican City State)</option>
                    <option value="Honduras">Honduras</option>
                    <option value="Hong Kong">Hong Kong</option>
                    <option value="Hungary">Hungary</option>
                    <option value="Iceland">Iceland</option>
                    <option value="India">India</option>
                    <option value="Indonesia">Indonesia</option>
                    <option value="Iran">Iran (Islamic Republic of)</option>
                    <option value="Iraq">Iraq</option>
                    <option value="Ireland">Ireland</option>
                    <option value="Israel">Israel</option>
                    <option value="Italy">Italy</option>
                    <option value="Jamaica">Jamaica</option>
                    <option value="Japan">Japan</option>
                    <option value="Jordan">Jordan</option>
                    <option value="Kazakhstan">Kazakhstan</option>
                    <option value="Kenya">Kenya</option>
                    <option value="Kiribati">Kiribati</option>
                    <option value="Democratic People's Republic of Korea">Korea, Democratic People's Republic of</option>
                    <option value="Korea">Korea, Republic of</option>
                    <option value="Kuwait">Kuwait</option>
                    <option value="Kyrgyzstan">Kyrgyzstan</option>
                    <option value="Lao">Lao People's Democratic Republic</option>
                    <option value="Latvia">Latvia</option>
                    <option value="Lebanon">Lebanon</option>
                    <option value="Lesotho">Lesotho</option>
                    <option value="Liberia">Liberia</option>
                    <option value="Libyan Arab Jamahiriya">Libyan Arab Jamahiriya</option>
                    <option value="Liechtenstein">Liechtenstein</option>
                    <option value="Lithuania">Lithuania</option>
                    <option value="Luxembourg">Luxembourg</option>
                    <option value="Macau">Macau</option>
                    <option value="Macedonia">Macedonia, The Former Yugoslav Republic of</option>
                    <option value="Madagascar">Madagascar</option>
                    <option value="Malawi">Malawi</option>
                    <option value="Malaysia">Malaysia</option>
                    <option value="Maldives">Maldives</option>
                    <option value="Mali">Mali</option>
                    <option value="Malta">Malta</option>
                    <option value="Marshall Islands">Marshall Islands</option>
                    <option value="Martinique">Martinique</option>
                    <option value="Mauritania">Mauritania</option>
                    <option value="Mauritius">Mauritius</option>
                    <option value="Mayotte">Mayotte</option>
                    <option value="Mexico">Mexico</option>
                    <option value="Micronesia">Micronesia, Federated States of</option>
                    <option value="Moldova">Moldova, Republic of</option>
                    <option value="Monaco">Monaco</option>
                    <option value="Mongolia">Mongolia</option>
                    <option value="Montserrat">Montserrat</option>
                    <option value="Morocco">Morocco</option>
                    <option value="Mozambique">Mozambique</option>
                    <option value="Myanmar">Myanmar</option>
                    <option value="Namibia">Namibia</option>
                    <option value="Nauru">Nauru</option>
                    <option value="Nepal">Nepal</option>
                    <option value="Netherlands">Netherlands</option>
                    <option value="Netherlands Antilles">Netherlands Antilles</option>
                    <option value="New Caledonia">New Caledonia</option>
                    <option value="New Zealand">New Zealand</option>
                    <option value="Nicaragua">Nicaragua</option>
                    <option value="Niger">Niger</option>
                    <option value="Nigeria">Nigeria</option>
                    <option value="Niue">Niue</option>
                    <option value="Norfolk Island">Norfolk Island</option>
                    <option value="Northern Mariana Islands">Northern Mariana Islands</option>
                    <option value="Norway">Norway</option>
                    <option value="Oman">Oman</option>
                    <option value="Pakistan">Pakistan</option>
                    <option value="Palau">Palau</option>
                    <option value="Panama">Panama</option>
                    <option value="Papua New Guinea">Papua New Guinea</option>
                    <option value="Paraguay">Paraguay</option>
                    <option value="Peru">Peru</option>
                    <option value="Philippines">Philippines</option>
                    <option value="Pitcairn">Pitcairn</option>
                    <option value="Poland">Poland</option>
                    <option value="Portugal">Portugal</option>
                    <option value="Puerto Rico">Puerto Rico</option>
                    <option value="Qatar">Qatar</option>
                    <option value="Reunion">Reunion</option>
                    <option value="Romania">Romania</option>
                    <option value="Russia">Russian Federation</option>
                    <option value="Rwanda">Rwanda</option>
                    <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option> 
                    <option value="Saint LUCIA">Saint LUCIA</option>
                    <option value="Saint Vincent">Saint Vincent and the Grenadines</option>
                    <option value="Samoa">Samoa</option>
                    <option value="San Marino">San Marino</option>
                    <option value="Sao Tome and Principe">Sao Tome and Principe</option> 
                    <option value="Saudi Arabia">Saudi Arabia</option>
                    <option value="Senegal">Senegal</option>
                    <option value="Seychelles">Seychelles</option>
                    <option value="Sierra">Sierra Leone</option>
                    <option value="Singapore">Singapore</option>
                    <option value="Slovakia">Slovakia (Slovak Republic)</option>
                    <option value="Slovenia">Slovenia</option>
                    <option value="Solomon Islands">Solomon Islands</option>
                    <option value="Somalia">Somalia</option>
                    <option value="South Africa">South Africa</option>
                    <option value="South Georgia">South Georgia and the South Sandwich Islands</option>
                    <option value="Span">Spain</option>
                    <option value="SriLanka">Sri Lanka</option>
                    <option value="St. Helena">St. Helena</option>
                    <option value="St. Pierre and Miguelon">St. Pierre and Miquelon</option>
                    <option value="Sudan">Sudan</option>
                    <option value="Suriname">Suriname</option>
                    <option value="Svalbard">Svalbard and Jan Mayen Islands</option>
                    <option value="Swaziland">Swaziland</option>
                    <option value="Sweden">Sweden</option>
                    <option value="Switzerland">Switzerland</option>
                    <option value="Syria">Syrian Arab Republic</option>
                    <option value="Taiwan">Taiwan, Province of China</option>
                    <option value="Tajikistan">Tajikistan</option>
                    <option value="Tanzania">Tanzania, United Republic of</option>
                    <option value="Thailand">Thailand</option>
                    <option value="Togo">Togo</option>
                    <option value="Tokelau">Tokelau</option>
                    <option value="Tonga">Tonga</option>
                    <option value="Trinidad and Tobago">Trinidad and Tobago</option>
                    <option value="Tunisia">Tunisia</option>
                    <option value="Turkey">Turkey</option>
                    <option value="Turkmenistan">Turkmenistan</option>
                    <option value="Turks and Caicos">Turks and Caicos Islands</option>
                    <option value="Tuvalu">Tuvalu</option>
                    <option value="Uganda">Uganda</option>
                    <option value="Ukraine">Ukraine</option>
                    <option value="United Arab Emirates">United Arab Emirates</option>
                    <option value="United Kingdom">United Kingdom</option>
                    <option value="United States">United States</option>
                    <option value="United States Minor Outlying Islands">United States Minor Outlying Islands</option>
                    <option value="Uruguay">Uruguay</option>
                    <option value="Uzbekistan">Uzbekistan</option>
                    <option value="Vanuatu">Vanuatu</option>
                    <option value="Venezuela">Venezuela</option>
                    <option value="Vietnam">Viet Nam</option>
                    <option value="Virgin Islands (British)">Virgin Islands (British)</option>
                    <option value="Virgin Islands (U.S)">Virgin Islands (U.S.)</option>
                    <option value="Wallis and Futana Islands">Wallis and Futuna Islands</option>
                    <option value="Western Sahara">Western Sahara</option>
                    <option value="Yemen">Yemen</option>
                    <option value="Serbia">Serbia</option>
                    <option value="Zambia">Zambia</option>
                    <option value="Zimbabwe">Zimbabwe</option>
                  </Select>
              </FormControl>
              </Box>
              <Text fontSize="sm">
                  By creating an account, you agree to our{" "}
                  <Link href="/legal/MyTradingTracker_Terms_and_Conditions.pdf" isExternal textDecoration="underline">Terms and Conditions</Link> and{" "}
                  <Link href="/legal/MyTradingTracker_Privacy_Policy.pdf" isExternal textDecoration="underline">Privacy Policy</Link>
              </Text>
              <Button
                borderRadius="md"
                type="submit"
                variant="solid"
                colorScheme="blue"
                width="full"
                onClick={handleSubmit}
              >
                Create account
              </Button>
              <HStack spacing={2}>
                <Divider />
                <Text fontSize="xs" color="gray.500" whiteSpace="nowrap">or</Text>
                <Divider />
              </HStack>
              <Center>
                <GoogleLogin
                  onSuccess={handleGoogleSuccess}
                  onError={handleGoogleError}
                  text="signup_with"
                  width="300"
                />
              </Center>
              <Text textAlign="center" fontSize="sm">
                Already have an account?{" "}
                <Link color="blue.500" href="/login" onClick={() => window.localStorage.removeItem('userInfo')}>
                  Log in
                </Link>
              </Text>
            </Stack>
          </form>
        }
        </Box>
      </Stack>
    </Flex>
  );
}